import { render, staticRenderFns } from "./SMSOnboardingStepTest.vue?vue&type=template&id=e8929df8&scoped=true"
import script from "./SMSOnboardingStepTest.vue?vue&type=script&lang=js"
export * from "./SMSOnboardingStepTest.vue?vue&type=script&lang=js"
import style0 from "./SMSOnboardingStepTest.vue?vue&type=style&index=0&id=e8929df8&prod&lang=scss&scoped=true"
import style1 from "./SMSOnboardingStepTest.vue?vue&type=style&index=1&id=e8929df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8929df8",
  null
  
)

export default component.exports